<template>
  <div class="custom-scale">
    <div class="inline-block">
      <ul class="flex justify-between">
        <li
          class="inline-block mr-2 last:mr-0 scale-wrap"
          v-for="(item, index) in issue.labels"
          :key="index"
          @click="issue.value = item.id"
        >
          <div class="scale-item whitespace-nowrap" :class="{ selected: issue.value === item.id }">
            <span v-if="issue.show_option_value">{{ item.num }}</span>
          </div>
          <div class="break-words custom-label-text" v-if="issue.show_option_desc">
            <span>{{ item.text }}</span>
          </div>
        </li>
      </ul>
    </div>
    <div class="unknown-box" key="unknown" v-if="issue.show_unknown">
      <el-radio v-model="issue.value" label="unknown">
        <span>{{ issue.unknown_text }}</span>
      </el-radio>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomSingleScale',
  props: {
    showOperate: {
      type: Boolean,
      default: true
    }
  },
  created() {},
  methods: {}
}
</script>
